
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { accountTypeService } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const DeleteAccountType = ({ data={}, loadData }) => {


  const deleteAccountType = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            accountTypeService.deleteAccountType(data.id).then(res => {
                toast.success('Account type deleted, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Account type');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteAccountType} />

    </Fragment>
  );
};

export default DeleteAccountType;
